import { get } from 'lodash'
import { required } from 'utils/validation'
import { LEVELS } from 'constants/enums'

const validate = values => {
  let errors = {}

  errors.awardLevel = {
    value: required(get(values, 'awardLevel.value'))
  }

  if (get(values, 'awardLevel.value') && get(values, 'awardLevel.value') !== LEVELS.BRONZE.id) {
    errors.helpers = {
      ...errors.helpers,
      previousCompletedAward: required(get(values, 'helpers.previousCompletedAward'))
    }
  }

  if (get(values, 'helpers.previousCompletedAward') === 'yes') {
    errors = {
      ...errors,
      previousCompletedAwardLevel: {
        value: required(get(values, 'previousCompletedAwardLevel.value'))
      },
      previousCompletedAwardPlace: required(values.previousCompletedAwardPlace)
    }
  }
  return errors
}

export default validate
